if(!customElements.get('collection-product-list')){
    class MainCollectionProductList extends HTMLElement {
        constructor(){
            super();

            this.id = this.dataset.id;
        }

        connectedCallback(){
            this.onLoadPaginationSubscriber = PubSub.subscribe(PubSub.events.onLoadPagination, this.handleCollectionLoad.bind(this));

            this.buttonViewSwitch = this.querySelector('.button-view-switch');
            if(this.buttonViewSwitch){
                this.buttonViewSwitch.addEventListener("click", this.switchView.bind(this));
                this.buttonViewSwitch.addEventListener("keydown", e => {
                    if(e.key === 'Enter'){
                        this.switchView(e);
                    }
                });
            }
        }

        disconnectedCallback(){
            if(this.onLoadPaginationSubscriber && typeof this.onLoadPaginationSubscriber === 'function'){
                this.onLoadPaginationSubscriber();
            }
        }

        handleCollectionLoad({ data, callback }){
            if(data.type !== 'product') return;
            
            this.pendingRequestUrl = data.url;
            const currentUrl = data.url || this.pendingRequestUrl;

            setTimeout(() => {
                this.renderContent({
                    requestUrl: `${currentUrl}`,
                    callback: this.loadContent({
                        callback: callback
                    })
                });
            }, 500);
        }

        renderContent({ requestUrl, callback }){
            this.abortController?.abort();
            this.abortController = new AbortController();

             fetch(requestUrl, { signal: this.abortController.signal })
                .then(res => res.text())
                .then(resText => {
                    this.pendingRequestUrl = null;
                    const html = new DOMParser().parseFromString(resText, 'text/html');
                    callback(html);
                })
                .catch(error => {
                    if(error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                    }else{
                        console.error(error);
                    }
                });
        }

        loadContent({ callback }){
            return (html) => {
                const productListWrapper = html.querySelector(`.collection-product-list[data-id="${this.id}"]`);
                this.productList = this.querySelector(".product-list");
                if(productListWrapper){
                    const productList = productListWrapper.querySelector('.product-list');
                    if(productList){
                        Array.from(productList.children).forEach(child => {
                            this.productList.appendChild(child.cloneNode(true));
                        });
                    }

                    const autoPagination = html.querySelector('auto-pagination');
                    if(autoPagination){
                        const url = autoPagination.dataset.url;
                        callback(url);
                    }
                }
            }
        }

        switchView(e){
            if(!this.buttonViewSwitch) return;

            if(this.buttonViewSwitch.dataset.minimized === 'true'){
                this.buttonViewSwitch.setAttribute("data-minimized", 'false');
                this.classList.remove('minimized');
            }else{
                this.buttonViewSwitch.setAttribute("data-minimized", 'true');
                this.classList.add('minimized');
            }
        }
    }

    customElements.define('collection-product-list', MainCollectionProductList);
}